import { extend } from 'underscore';
import { entitySelectorStyle, paginationStyle } from './shared-styles-from-theme-fluent';
import type { CommonStylesDefinition, CommonStylesOptions, CommonStylesPalette } from '../types.d';


const campaignMultiSelector = ({ palette = {} as CommonStylesPalette, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '& .ba-campaign-selector .ba-entity-selector': {
    minWidth: 300,
  },
  '& .ba-campaign-selector .list-selector-content .add-arrow-button': {
    position: 'absolute',
    top: '20%',
    right: 10,
  },
  '& .ba-campaign-selector .list-selector-content .remove-arrow-button': {
    position: 'absolute',
    top: '2%',
    right: 10,
  },
  '& .list-selector-content .remove-arrow-button': {
    position: 'absolute',
    top: '2%',
    right: 10,
  },
  '& .list-selector-content .add-arrow-button': {
    position: 'absolute',
    right: 10,
  },
  '& .ba-entity-selector': {
    minWidth: 300,
  },
  '& .ba-search-box ': {
    borderTop: `1px solid ${palette.neutralSecondary}`,
    borderLeft: `1px solid ${palette.neutralSecondary}`,
    borderRight: `1px solid ${palette.neutralSecondary}`,
    padding: 1,
    position: 'relative',

    '& .search-box__input': {
      height: 48,
      width: 'calc(100% - 2px)',
      border: 0,
      borderBottom: `1px solid ${palette.neutralLight}`,
      paddingLeft: 48,
      marginLeft: 1,
    },

    '& .search-box__icon': {
      fontFamily: iconFontFamily,
      fontSize: 16,
      verticalAlign: 'middle',
      position: 'absolute',
      left: 16,
      top: 16,
    },

    '& .search-box__icon:before': {
      content: '"\\E721"',
      color: palette.themePrimary,
    },
  },
  '& .multi-selector': {
    border: 'none',
    '& .ba-pagination': {
      '& .pager-input': {
        width: '70px',
      },
    },
    '& .ba-list-selector': {
      borderTop: '0px',
      borderBottom: `1px solid ${palette.neutralSecondary}`,
      borderLeft: `1px solid ${palette.neutralSecondary}`,
      borderRight: `1px solid ${palette.neutralSecondary}`,
      '& .list-selector-header': {
        '& .panel-heading': {
          color: palette.neutralPrimary,
          fontSize: 14,
          padding: '7px 8px',

          '& .panel-title': {
            fontSize: 14,
            marginTop: 0,
          },
        },
      },
      '& .list-selector-action-bar': {
        '& [class*="-all-content"]': {
          padding: '10px 8px',
          color: '#0078D4',
          cursor: 'pointer',
          '& span': {
            '&:hover': {
              color: '#004578',
              textDecorationLine: 'underline',
            },
          },
        },
        '& .select-all-content .enabled.arrow-button': {
          float: 'right',
        },
        '& .remove-all-content .remove.arrow-button': {
          marginTop: 0,
        },
      },
      '& .list-selector-content': {
        height: 380,
        '& .list-selector-item': {
          padding: '7px 8px 8px 8px',
          margin: 0,
          minHeight: 36,

          '& .item-content': {
            maxWidth: 225,
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            cursor: 'pointer',

            '& .statusIcon': {
              verticalAlign: 'middle',
              height: '19px',
            },

            '& .text': {
              marginLeft: 10,
              verticalAlign: 'middle',
            },
          },
          '& .statusEnabled_icon::before': {
            color: '#107c10',
            content: '"\\ECCC"',
            fontFamily: iconFontFamily,
          },
          '& .statusPaused_icon::before': {
            color: '#323130',
            content: '"\\F6B0"',
            fontFamily: iconFontFamily,
          },
          '& .statusDeleted_icon::before': {
            color: '#FF0000',
            content: '"\\E738"',
            fontFamily: iconFontFamily,
          },
        },
      },
      '& .list-selector-item:hover': {
        background: palette.neutralLight,
      },

      '& .list-selector-item:focus': {
        outline: `1px solid ${palette.neutralSecondary}`,
        outlineOffset: -1,
      },
      '& .list-selector-empty': {
        marginLeft: 10,
      },
      '& .pagination-container': {
        '& .ba-pagination': {
          height: 36,
          padding: '6px 0',
          paddingBottom: 0,
        },
      },
      '& .arrow-button': {
        color: '#0078D4',
      },
      '& .arrow-button.enabled': {
        marginLeft: 10,
        overflow: 'visible !important',
        textDecoration: 'none !important',
        background: 'none !important',
        fontFamily: iconFontFamily,
        cursor: 'pointer',
      },

      '& .arrow-button.enabled:before': {
        content: '"\\E710"',
      },

      '& .arrow-button.remove': {
        marginRight: 10,
        marginTop: 8,
        float: 'right',
        fontFamily: iconFontFamily,
        padding: 0,

      },

      '& .list-selector-content .arrow-button.remove': {
        marginTop: 0,
        top: '50%',
        transform: 'translate(0, -50%)',
        '-webkit-transform': 'translate(0, -50%)',
      },

      '& .arrow-button.remove:before': {
        content: '"\\E738"',
      },

      '& .arrow-button.remove+a': {
        width: 'fit-content',
        padding: 0,
      },
    },
    '& .multi-selector-result-container': {
      margin: '0 0 0 8px',
      '& .list-selector-container .ba-list-selector': {
        height: '351px',
        borderTop: `1px solid ${palette.neutralSecondary}`, // no search box on top of the result container
      },
    },
  },
});

const accountMultiSelector: (options: CommonStylesOptions) => CommonStylesDefinition = () => ({
  '& .ba-campaign-selector .dropdown-menu .ba-list-selector .list-selector-content .list-selector-item > div.account-selector-rowitem': {
    maxWidth: 283,
  },
});

export const campaignMultiSelectorWithoutDropdownStyle = ({ palette = {} as CommonStylesPalette }) => extend(
  {},
  entitySelectorStyle({ palette }),
  paginationStyle({ palette }),
  campaignMultiSelector({ palette }),
  accountMultiSelector({ palette })
);
